import { RefObject, useRef } from "react";

export function usePreviousValue<T>(value: T): T | undefined {
	const previousValueRef: RefObject<T | undefined> = useRef<T>(undefined);
	const previousValue: T | undefined = previousValueRef.current;
	previousValueRef.current = value;

	return previousValue;
}